import React, {useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import JobServices from '../../../../../services/job'

type Props = {
  job: any
  toggle: any
}

const ApplyForm: React.FC<Props> = ({job, toggle}) => {
  const navigate = useNavigate()
  const [description, setDescription] = useState('')
  const [submit, setSubmit] = useState(false)
  const applyJob = async (e: any) => {
    try {
      e?.preventDefault()
      setSubmit(true)

      const param = {
        job_id: job?.company_jobs_id,
        description: description,
      }
      await JobServices.jobApplyPost(param)
      toast.success('Lamaran berhasil dikirim')
      navigate('/my-applicant')
    } catch (error) {
    } finally {
      setSubmit(false)
      toggle()
    }
  }
  return (
    <Form onSubmit={applyJob}>
      <Form.Label>Pesan (Opsional)</Form.Label>
      <ReactQuill theme='snow' value={description} onChange={setDescription} readOnly={submit} />
      <div style={{float: 'right'}} className='mt-8'>
        <Button variant='secondary' disabled={submit} onClick={toggle}>
          Batalkan
        </Button>
        {'   '}
        <Button type='submit' disabled={submit}>
          {submit ? 'Loading...' : 'Lamar'}
        </Button>
      </div>
    </Form>
  )
}

export default ApplyForm
